/**
 * Manage global libraries from the package.json file
 */

/**
 * Import libraries
 */
// Lazy load library
// import 'lazysizes';
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import "lazysizes/plugins/bgset/ls.bgset";
import "lazysizes/plugins/respimg/ls.respimg";
// import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

// Import custom modules
// import GoogleAnalytics from './modules/google-analytics';
import NavMenu from "./modules/nav-menu";
import IntlTelephoneInput from "./modules/IntlTelephoneInput"
// import FooterGoogleMap from "./modules/footer-google-map";
// import ShortcodeServices from "./modules/shortcode-services";
import GlobalPopup from './modules/global-popup';

// const ga_id = main_object.google_analytics.ga_id
// if ( ga_id ) {
// 	new GoogleAnalytics( ga_id )
// }

new NavMenu();
new GlobalPopup()
new IntlTelephoneInput()